<template >
	<div class="progress-block">
		<div class="progress-block__wrapper">
			<div v-for='i of countOfBlocks'
           :key="i"
           :id="(i - 1)"
           :style="{ '--light-color': lightColor, '--main-color': mainColor, '--active-color': activeColor }"
           class="progress-block__item">
      </div>
      <div :id="(countOfBlocks)"
           :style="{ '--light-color': lightColor, '--main-color': mainColor, '--active-color': activeColor }"
           class="progress-block__item"
           v-if="agreeSlide"
      >
      </div>
		</div>
	</div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
	mounted() {
		if (document.getElementById("0")) {
			document.getElementById("0").classList.add("active");
		}

		if (this.done) {
			let arr = document.querySelectorAll('.progress-block__item');
			arr.forEach(i => i.classList.add('done'))
		}
	},
  props: {
		countOfBlocks: Number,
    isOSHA: {
      type: Boolean,
      default: false,
    },
		done: Boolean,
    agreeSlide: {
      type: Boolean,
      default: true
    },
	},

  computed: {
    ...mapGetters("app",["getRoleById"]),

    lightColor() {
      return this.changeHex(this.mainColor, 20)
    },

    darkColor() {
      return this.changeHex(this.mainColor, 20, true)
    },
    mainColor() {
      if (this.isOSHA) return this.getRoleById(12).color
      else return this.getRoleById(3).color
    },

    activeColor() {
      return '#57c766'
    },
  },

	methods: {
		changeSlide(idx) {
			this.$emit('changeSlideMark', idx)
		},

    changeHex(hex, percent = 20, dark = false) {
      const num = parseInt(hex.replace('#', ''), 16)
      const amt = Math.round(2.55 * percent)

      const r = Math.min(255, dark ? (num >> 16) - amt : (num >> 16) + amt)
      const g = Math.min(255, dark ? (num >> 8 & 0x00FF) - amt : (num >> 8 & 0x00FF) + amt)
      const b = Math.min(255, dark ? (num & 0x0000FF) - amt : (num & 0x0000FF) + amt)

      return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
    }
	},
}
</script>
<style lang="scss">
@import '@/sass/_vars';

.progress-block {
	width: 100%;
	margin-top: 24px;

	&__wrapper {
		display: flex;
		border-radius: 0.5rem;
		overflow: hidden;
		box-sizing: border-box;
		background-color: rgb(223, 223, 223);
	}

	&__item {
		box-sizing: border-box;
		height: 25px;
		flex-grow: 1;
		flex-basis: auto;
		position: relative;

		transition: all 0.5s linear;

		>.i {
			position: absolute;
			top: 40%;
			left: 50%;
		}

		&.done {
      background: linear-gradient(to right, var(--light-color) 0%, var(--main-color) 50%);
		}

		&.active {
			background-color: var(--active-color);
		}

		&.done.active {
			background: none;
      background-color: var(--active-color);
		}
	}
}
</style>
